module.exports = __webpack_public_path__ + "static/media/coffee-togo.47065014.svg";